import {
  Loader2,
  Users,
  Heart,
  AlertTriangle,
  XCircle,
  Star,
  CalendarX,
  TrendingUp,
  GitBranch,
} from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { KpiCard } from '@/components/ui/Card'
import { useCsDashboard } from '@/hooks/useCsDashboard'

export default function CsDashboardPage() {
  const { data, loading, error } = useCsDashboard()

  return (
    <DashboardLayout title='Sucesso do Cliente — Painel'>
      {loading && (
        <div className='flex h-48 items-center justify-center'>
          <Loader2 className='animate-spin text-[var(--brand-primary)]' size={28} />
        </div>
      )}

      {error && <p className='text-sm text-rose-400'>{error}</p>}

      {data && (
        <div className='space-y-6'>
          <p className='text-sm text-[var(--text-muted)]'>
            Indicadores da carteira CS (saúde 0–18). Valores financeiros ficam restritos a Manager/Admin na
            ficha.
          </p>
          <div className='grid grid-cols-2 gap-4 lg:grid-cols-4'>
            <KpiCard label='Total de clientes' value={String(data.totalAccounts)} icon={<Users size={16} className='text-blue-400' />} />
            <KpiCard label='Saudáveis' value={String(data.greenCount)} icon={<Heart size={16} className='text-emerald-400' />} />
            <KpiCard label='Em atenção' value={String(data.yellowCount)} icon={<AlertTriangle size={16} className='text-amber-400' />} />
            <KpiCard label='Em risco' value={String(data.redCount)} icon={<XCircle size={16} className='text-rose-400' />} />
          </div>
          <div className='grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'>
            <KpiCard label='Risco de churn' value={String(data.riscoChurnCount)} icon={<XCircle size={16} className='text-rose-400' />} />
            <KpiCard label='Sem reunião 30d+' value={String(data.semReuniao30d)} icon={<CalendarX size={16} className='text-amber-400' />} />
            <KpiCard label='NPS médio' value={data.npsAvg != null ? String(data.npsAvg) : '—'} icon={<Star size={16} className='text-amber-400' />} />
            <KpiCard
              label='Upsells em andamento'
              value={String(data.upsellsEmAndamento ?? 0)}
              icon={<TrendingUp size={16} className='text-emerald-400' />}
            />
            <KpiCard
              label='Cross-sells em andamento'
              value={String(data.crossSellsEmAndamento ?? 0)}
              icon={<GitBranch size={16} className='text-blue-400' />}
            />
          </div>
        </div>
      )}
    </DashboardLayout>
  )
}
